function webpackDevServerHost(appName) {
  // process.env has to be defined at webpack build time, so we can't make these dynamic
  if (appName === 'bridge-authorization') {
    return (
      process.env.AUTHORIZATION_WEBPACK_DEV_SERVER_HOST || 'localhost:9190'
    );
  }
  if (appName === 'bridge-tools') {
    return process.env.TOOLS_WEBPACK_DEV_SERVER_HOST || 'localhost:9191';
  }
  return process.env.WEBPACK_DEV_SERVER_HOST || 'localhost:9090';
}

export default function prependAssetPrefix(app, path) {
  if (process.env.USE_WEBPACK_DEV_SERVER === '1') {
    return 'http://' + webpackDevServerHost(app.name) + path;
  }
  if (process.env.DEPLOY_ENV && app.cdn && app.cdn[process.env.DEPLOY_ENV]) {
    return app.cdn[process.env.DEPLOY_ENV] + path;
  }
  if (process.env.CDN_URL) {
    return process.env.CDN_URL + path;
  }
  return path;
}



// WEBPACK FOOTER //
// ./jsapp/learnRuntime/prependAssetPrefix.js